import { CatalogSamplesCreate } from "./CatalogSamplesCreate";
import { CatalogSamplesList } from "./CatalogSamplesList";
import CatalogSamplesShow from "./CatalogSamplesShow";
import CatalogSamplesEdit from "./CatalogSamplesEdit";

export const catalog_samples = {
  list: CatalogSamplesList,
  create: CatalogSamplesCreate,
  edit: CatalogSamplesEdit,
  show: CatalogSamplesShow,
};
